import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";
export default {
  namespaced: true,
  state: {
    dicionarios: [],
    termos: [],
    termoAtivo: null,
  },
  mutations: {
    setDicionarios(state, lista) {
      state.dicionarios = lista;
    },
    setTermos(state, lista) {
      state.termos = lista;
    },
    setTermoAtivo(state, termo) {
      state.termoAtivo = termo;
    },
  },
  actions: {
    async listarTermos({ commit }, { dicionario, opcoes }) {
      try {
        const response = await securedAxios.get(
          `/taxonomia/dicionarios/${dicionario}/termos?opcoes=${urljson(
            opcoes
          )}`
        );
        commit("setTermos", response.data);
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async salvarTermo(context, { dicionario, termo }) {
      try {
        let p;
        if (termo.id === "") {
          p = securedAxios.post(
            `/taxonomia/dicionarios/${dicionario}/termos`,
            termo
          );
        } else {
          p = securedAxios.put(
            `/taxonomia/dicionarios/${dicionario}/termos/${termo.id}`,
            termo
          );
        }
        const response = await p;
        return Promise.resolve(response.data);
      } catch (err) {
        console.log(err);
        return Promise.reject(err);
      }
    },
    async deletarTermo(contexto, { dicionario, id }) {
      try {
        await securedAxios.delete(
          `/taxonomia/dicionarios/${dicionario}/termos/${id}`
        );
        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
